import useUserBlock from "../../users/hooks/useUserBlock";

const useStaffBlock = () => {
  return useUserBlock(true);
};

export default useStaffBlock;
